//  icons
import {
  FiPhone,
  FiLayout,
  FiSettings,
  FiPenTool,
  FiTag,
  FiMapPin,
} from 'react-icons/fi';
import {
  FaReact, FaHtml5, FaAngellist,
} from 'react-icons/fa';
import {
  SiJavascript, SiPostgresql, SiRedux, SiBootstrap, SiStripe, SiCss3,
} from 'react-icons/si';
import {
  DiRuby
} from 'react-icons/di';
import {
  TbBrandDiscord,
  TbBrandNextjs, TbBrandStripe
} from 'react-icons/tb';
import {
  BiCloud
} from 'react-icons/bi';
import {
  MdPublic, MdPersonOutline, MdOutlineFavoriteBorder,
} from 'react-icons/md';
import Sphere from "./icons";
import UseAnimation from "react-useanimations";
import github from 'react-useanimations/lib/github';
import twitter from 'react-useanimations/lib/twitter';
import linkedin from 'react-useanimations/lib/linkedin';
import mail from 'react-useanimations/lib/mail';
import visibility from 'react-useanimations/lib/visibility';

// companies icons
import FreelancerBrandIcon from './assets/img/brands/freelancer.png';
import UpworkBrandIcon from './assets/img/brands/upwork.png';
import FiverBrandIcon from './assets/img/brands/fiverr.png';
import BehanceBrandIcon from './assets/img/brands/behance.png';
import DribbbleBrandIcon from './assets/img/brands/dribbble.png';

// projects images
import Project1 from './assets/img/projects/11.png';
import Project2 from './assets/img/projects/22.png';
import Project3 from './assets/img/projects/33.png';
import Project4 from './assets/img/projects/44.png';
import Project5 from './assets/img/projects/99.png';
import Project6 from './assets/img/projects/66.png';

// skills images
import SkillImg1 from './assets/img/skills/html5.png';
import SkillImg2 from './assets/img/skills/css3.png';
import SkillImg3 from './assets/img/skills/js.png';
import SkillImg4 from './assets/img/skills/reactjs.png';
import SkillImg5 from './assets/img/skills/nextjs.png';
import SkillImg6 from './assets/img/skills/nodejs.png';
import SkillImg7 from './assets/img/skills/git.png';
import SkillImg8 from './assets/img/skills/figma.png';
import SkillImg9 from './assets/img/skills/bootstrab.png';
import SkillImg10 from './assets/img/skills/docker.png';
import SkillImg11 from './assets/img/skills/eslint.png';
import SkillImg12 from './assets/img/skills/fontaw.png';
import SkillImg13 from './assets/img/skills/github.png';
import SkillImg14 from './assets/img/skills/jest.png';
import SkillImg15 from './assets/img/skills/json.png';
import SkillImg16 from './assets/img/skills/mangodb.png';
import SkillImg17 from './assets/img/skills/mysql.png';
import SkillImg18 from './assets/img/skills/npm.png';
import SkillImg19 from './assets/img/skills/postgresql.png';
import SkillImg20 from './assets/img/skills/rails.png';
import SkillImg21 from './assets/img/skills/redux.png';
import SkillImg22 from './assets/img/skills/sass.png';
import SkillImg23 from './assets/img/skills/git.png';
import SkillImg24 from './assets/img/skills/swagger.png';
import SkillImg25 from './assets/img/skills/typescript.png';
import SkillImg26 from './assets/img/skills/vscode.png';
import SkillImg27 from './assets/img/skills/aws.png';
import SkillImg28 from './assets/img/skills/firebase.png';
import SkillImg29 from './assets/img/skills/webpack.png';
import SkillImg30 from './assets/img/skills/ruby.png';


// navigation
export const navigation = [
  {
    name: 'home',
    href: 'home',
  },
  {
    name: 'about',
    href: 'about',
  },
  {
    name: 'skills',
    href: 'skills',
  },
  {
    name: 'portfolio',
    href: 'portfolio',
  },
  {
    name: 'services',
    href: 'services',
  },
  {
    name: 'contact',
    href: 'contact',
  },
];

// home
export const home = [
  {
    text: "HELLO I'M",
    name: "SadiQ HabiL",
    post: "Full Stack Developer",
    design: "Frontend",
    design1: "Backend",
    design2: "UI / UX DESIGNER",
    desc: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book",
  },
]

// social
export const social = [
  {
    icon: <UseAnimation  animation={github} size={30} strokeColor='#e0a80d' fillColor='#1d4ed8' />,
    href: 'https://https://github.com/kingqabil',
  },
  {
    icon: <UseAnimation animation={twitter} size={30} strokeColor='#e0a80d'  />,
    href: 'https://https://twitter.com/kingqabil',
  },
  {
    icon: <TbBrandDiscord color='#e0a80d' size={22} />,
    href: 'https://discordapp.com/users/Kingqabil#1042',
  },
  {
    icon: <FaAngellist color='#e0a80d' size={22} />,
    href: 'https://https://angel.co/u/sadiq-habil',
  },
  {
    icon: <UseAnimation  animation={linkedin} size={30} strokeColor='#e0a80d' />,
    href: 'https://https://www.linkedin.com/in/kingqabil/',
  },
];

// companies
export const brands = [
  {
    img: FreelancerBrandIcon,
    href: '',
  },
  {
    img: UpworkBrandIcon,
    href: '',
  },
  {
    img: FiverBrandIcon,
    href: '',
  },
  {
    img: BehanceBrandIcon,
    href: '',
  },
  {
    img: DribbbleBrandIcon,
    href: '',
  },
];

// projects
export const projectsData = [
  {
    id: '1',
    image: Project1,
    name: 'Book an Appointment',
    category: 'Development',
    icon:<UseAnimation animation={github} size={30}  />,
    href:'https://github.com/kingqabil/premium-hotel-frontend',
    description: 'Book an Appointment frontend is the frontend of the Book an Appointment app. The theme of the app is Hotels.',
    icon1: <UseAnimation animation={visibility} size={30}  />,
    href1:'https://illustrious-manatee-a1d62c.netlify.app/',
    icon3: <FaReact/>,
    icon4: <FaHtml5 />,
    icon5: <SiJavascript />,
    icon6: <SiRedux />,
    icon7: <DiRuby />,
    icon8: <SiPostgresql />,
  },
  {
    id: '2',
    image: Project2,
    name: 'Book Store',
    category: 'Development',
    icon:<UseAnimation animation={github} size={30} />,
    href:'https://github.com/kingqabil/bookstore',
    icon1: <UseAnimation animation={visibility} size={30} />,
    href1:'https://beautiful-paprenjak-8accd9.netlify.app/',
    description: 'Bookstore is an app that allows you to display a list of added books, add new book and remove a book. It is built using React, Redux ...',
    icon3: <FaReact/>,
    icon4: <SiBootstrap />,
    icon5: <SiJavascript />,
    icon6: <SiRedux />,
  },
  {
    id: '3',
    image: Project3,
    name: 'E-commerce',
    category: 'Development',
    icon:<UseAnimation animation={github} size={30} />,
    href:'https://github.com/kingqabil/ecommerce',
    icon1: <UseAnimation animation={visibility} size={30} />,
    href1:'http://ecommerce-kingqabil.vercel.app/',
    description: 'Fully Responsive modern Full stack E-commerce Application with payments.',
    icon3: <FaReact/>,
    icon4: <TbBrandNextjs />,
    icon5: <SiStripe />,
    icon6: <TbBrandStripe />,

  },
  {
    id: '4',
    image: Project4,
    name: 'Leaderboard',
    category: 'branding',
    icon:<UseAnimation animation={github} size={30} />,
    href:'https://github.com/kingqabil/Leaderboard',
    icon1: <UseAnimation animation={visibility} size={30} />,
    href1:'https://resilient-unicorn-1b69a3.netlify.app/',
    description: 'Leaderboard API using JavaScript async and await and add some styling.',
    icon4: <FaHtml5 />,
    icon5: <SiCss3 />,
    icon6: <SiJavascript />,
  },
  {
    id: '5',
    image: Project5,
    name: 'Covid-Stats-App',
    category: 'Development',
    icon:<UseAnimation animation={github} size={30} />,
    href:'https://github.com/kingqabil/covid-status-app',
    icon1: <UseAnimation animation={visibility} size={30} />,
    href1:'https://covid19-stat-app.herokuapp.com/',
    description: 'The Covid-stats-app allows users to have access to the latest covid data in Spain. They can also filter by region name, as well as get more informations on that specific region by clicking on it.',
    icon3: <FaReact/>,
    icon4: <FaHtml5 />,
    icon5: <SiCss3 />,
    icon6: <SiRedux />,
  },
  {
    id: '6',
    image: Project6,
    name: 'Math Magician',
    category: 'Design',
    icon:<UseAnimation animation={github} size={30} />,
    href:'https://github.com/kingqabil/math-magicians',
    icon1: <UseAnimation animation={visibility} size={30} />,
    href1:'https://math-magicians11.herokuapp.com/',
    description: 'Math magicians is a website for all fans of mathematics. It is a Single Page App (SPA) that allows users to make simple calculations and read a random math-related quote. ',
    icon3: <FaReact/>,
    icon4: <FaHtml5 />,
    icon5: <SiCss3 />,
    icon6: <SiJavascript />,
  },
];

// projects
export const projectsNav = [
  {
    name: 'all',
  },
  {
    name: 'Design',
  },
  {
    name: 'Development',
  },
  {
    name: 'Branding',
  },
];

// project
export const project = [
  {
    icon: <BiCloud />,
    num: "89",
    title: "HAPPY CLIENTS",
  },
  {
    icon: <MdOutlineFavoriteBorder />,
    num: "231",
    title: "PROJECTS COMPLETED",
  },
  {
    icon: <MdPublic />,
    num: "108",
    title: "FILES DOWNLOADED",
  },
  {
    icon: <MdPersonOutline />,
    num: "50000",
    title: "LINES OF CODE",
  },
]

// skill
export const skills = [
  {
    image: SkillImg1,
  },
  {
    image: SkillImg2,
  },
  {
    image: SkillImg3,
  },
  {
    image: SkillImg4,
  },
  {
    image: SkillImg5,
  },
  {
    image: SkillImg6,
  },
  {
    image: SkillImg7,
  },
  {
    image: SkillImg8,
  },
  {
    image: SkillImg9,
  },
  {
    image: SkillImg10,
  },
  {
    image: SkillImg11,
  },
  {
    image: SkillImg12,
  },
  {
    image: SkillImg13,
  },
  {
    image: SkillImg14,
  },
  {
    image: SkillImg15,
  },
  {
    image: SkillImg16,
  },
  {
    image: SkillImg17,
  },
  {
    image: SkillImg18,
  },
  {
    image: SkillImg19,
  },
  {
    image: SkillImg20,
  },
  {
    image: SkillImg21,
  },
  {
    image: SkillImg22,
  },
  {
    image: SkillImg23,
  },
  {
    image: SkillImg24,
  },
  {
    image: SkillImg25,
  },
  {
    image: SkillImg26,
  },
  {
    image: SkillImg27,
  },
  {
    image: SkillImg28,
  },
  {
    image: SkillImg29,
  },
  {
    image: SkillImg30,
  },
];

// cards
export const cards = [
  {
    icon: <Sphere />,

  },
];

// services
export const services = [
  {
    icon: <FiLayout />,
    name: 'Web Design',
    description:
      'web graphic design; user interface design (UI design); authoring, including standardized code and proprietary software; user experience design (UX design); and search engine optimization.',
  },
  {
    icon: <FiSettings />,
    name: 'Web Development',
    description:
      'Web design, Web content development, client liaison, client-side/server-side scripting, Web server and network security configuration, and e-commerce development. ',
  },
  {
    icon: <FiPenTool />,
    name: 'Branding',
    description:
      'create, plan, measure, and manage branding strategies for clients, including support in advertising and other forms of promotion.',
  },
  {
    icon: <FiTag />,
    name: 'SEO',
    description:
      'Identify strategies, techniques and tactics to increase the number of visitors to a website and obtain a high-ranking placement in the results page of search engines. ',
  },
];

// contact
export const contact = [
  {
    icon: <FiMapPin />,
    title: 'Current Location',
    subtitle: 'Burao, Somalia',
    description: 'Serving clients worldwide',
  },
  {
    icon: <FiPhone />,
    title: 'My Phone Number',
    description: '+252 63 414 6815',
  },
  {
    icon: <UseAnimation animation={mail} size={35} strokeColor='#e0a80d' />,
    title: 'Have a question?',
    subtitle: 'I am here to help you.',
    description: 'Email me at kingqabil@gmail.com',
  },
];
